import _ from 'lodash';
import { Model } from './Model';

export class Station extends Model {

  static validators = {
  };

  /**
   * @property id
   *
   * ID.
   *
   * @type {string}
   */

  /*
   * @property name
   *
   * Name.
   *
   * @type {string}
   */

  /**
   * @property type
   *
   * Type.
   *
   * @type {string}
   */

  /**
   * @property flags
   *
   * Flags.
   *
   * @type {string[]}
   */

  /**
   * @property addresses
   *
   * IP Addresses.
   *
   * @type {string[]}
   */

}
